<template lang="pug">
  transition(name="fade")
    .widget_header(
      @click.stop='edit_widget'
      v-if='show_header'
      :class='{ "widget_header--offset": is_offset }')
      .pull-left
        span
          i.pbxx-icon.pbxx-icon-arrows
      .pull-right
        span.edit_widget
          i.pbxx-icon.pbxx-icon-edit
        span(@click.stop='delete_widget')
          i.pbxx-icon.pbxx-icon-delete
</template>

<script>

  // @vue/component
  export default {
    name: 'widget_header',
    props: {
      widget: {
        type: Object,
        required: false
      },
      show_header: {
        type: Boolean,
        required: false
      },
      is_edit: {
        type: Boolean,
        required: false
      },
      is_offset: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    methods: {
      edit_widget() {
        this.$emit('edit_widget', this.widget)
      },
      delete_widget() {
        this.$confirm('This will permanently remove this widget.', 'Delete Widget', {
          confirmButtonText: 'Delete',
          confirmButtonClass: 'el-button--danger',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.$emit('delete_widget', this.widget)
        }).catch(() => {})
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/variables_and_mixins';
  .widget_header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 10px;
    background: rgba(0,0,0,0.5);
    color: get-color(gray-lightest);
    font-size: 1.5em;
    z-index: 11;
    cursor: pointer;

    .pull-left {
      span {
        cursor: move;
      }
    }

    .pull-right {
      span {
        &.edit_widget {
          margin-right: 20px;
        }
      }
    }
    &--offset {
      top: -40px;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    @include transition-property(opacity);
    @include transition-duration(0.5s);
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
